import { apiClient } from '../lib/api';
import type { Address } from '../types';

export const addressService = {
    getAddresses: async (): Promise<Address[]> => {
        return apiClient.request<Address[]>('/user/addresses/');
    },

    createAddress: async (address: Omit<Address, 'uuid' | 'created_at'>): Promise<Address> => {
        return apiClient.request<Address>('/user/addresses/', {
            method: 'POST',
            body: JSON.stringify(address),
        });
    },

    updateAddress: async (id: string, address: Partial<Address>): Promise<Address> => {
        return apiClient.request<Address>(`/user/addresses/${id}/`, {
            method: 'PATCH',
            body: JSON.stringify(address),
        });
    },

    deleteAddress: async (id: string): Promise<void> => {
        return apiClient.request<void>(`/user/addresses/${id}/`, {
            method: 'DELETE',
        });
    },
};
